module.exports = __webpack_public_path__ + "static/media/Employee_Network.2fce7ad3.png";